<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->
<h1 mat-dialog-title>User Map for {{data.userId}}</h1>
<div class="users-div">
  <mat-card appearance="outlined" class="mat-card-container default-padding">
    <fab-loading-spinner color="primary" *ngIf="showSpinner"></fab-loading-spinner>
    <div class="gfs-table">
      <ag-grid-angular
        style="height: 100%; width:100%;"
        class="ag-theme-quartz"
        [rowData]="fcorgRegionMapData"
        [columnDefs]="fcorgRegionMapColumns"
        [autoSizeStrategy]="autoSizeStrategy"
        [pagination]="true"
        [paginationPageSize]="10"
        [paginationPageSizeSelector]="[10, 20, 50, 100]"

      />
    </div>
  </mat-card>
</div>
